module.exports = __webpack_public_path__ + "img/labmem_text_btnfinish_en.daf9dba0.png";